
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 2H10V4H4V10H2V2ZM14 2H22V10H20V4H14V2ZM2 14H4V20H10V22H2V14ZM22 14V22H14V20H20V14H22Z" fill="currentColor"></path></svg>';export default svg;
    